export default __webpack_public_path__ + "static/media/how-it-works--tablet.be61b001.jpg";